<template>
  <div class="page-default">
    <div class="dashboard-section">
      <div class="cases-group">
        <div class="row h-100">
          <div
            class="
              col-12
              h-auto
              d-flex
              justify-content-between
              align-items-center
            "
          >
            <div class="btn-group btn-group-sm shadow-sm border">
              <button
                class="btn px-3"
                :class="currentView == 'card' ? 'btn-primary' : 'btn-light'"
                @click="currentView = 'card'"
              >
                <font-awesome-icon :icon="['fas', 'th']" />
              </button>
              <button
                class="btn px-3"
                :class="currentView == 'list' ? 'btn-primary' : 'btn-light'"
                @click="currentView = 'list'"
              >
                <font-awesome-icon :icon="['fas', 'list']" />
              </button>
            </div>
            <div
              class="d-flex justify-content-end align-items-center text-muted"
            >
              <label
                class="custom-control-label no-pseudo pr-2 small clickable"
                for="switchLocal"
                :class="{ 'text-primary font-weight-medium': !isLocal }"
              >
                All
              </label>
              <div class="custom-control custom-switch">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="switchLocal"
                  v-model="isLocal"
                />
                <label class="custom-control-label clickable" for="switchLocal">
                  &nbsp;
                </label>
              </div>
              <label
                class="custom-control-label no-pseudo small clickable"
                for="switchLocal"
                :class="{ 'text-primary font-weight-medium': isLocal }"
              >
                Johor only
              </label>
            </div>
          </div>
          <template v-if="currentView == 'card'">
            <div
              v-if="computedCases.length < 1"
              class="
                small
                text-muted
                font-italic
                h-100
                w-100
                d-flex
                justify-content-center
                align-items-center
              "
            >
              No social media cases found.
            </div>
            <div
              class="col-12 col-sm-6 col-md-4"
              v-for="(c, index) in computedCases"
              :key="`cases${index}`"
              style="height: calc(100% - 46px)"
            >
              <div class="case-container">
                <div class="case-header text-uppercase text-dark">
                  <div class="case-title">
                    <font-awesome-icon
                      :icon="getCaseIcon(c.type).i"
                      class="mr-2"
                      :class="`text-${getCaseIcon(c.type).color}`"
                    />{{ helper.titleCase(c.type) }} ({{ c.data.length }})
                  </div>
                </div>
                <div class="case-body">
                  <div
                    class="case-list no-pointer"
                    v-for="cl in c.data"
                    :key="cl._id"
                  >
                    <div
                      :class="
                        c.type !== 'whatsapp' &&
                        'd-flex justify-content-between'
                      "
                    >
                      <div
                        class="media"
                        :style="
                          c.type !== 'whatsapp' &&
                          'width: 60%; work-break: break-word;'
                        "
                      >
                        <div class="media">
                          <img
                            :src="cl.socmedAvatarUrl"
                            class="mr-3 media-image"
                            v-if="cl.socmedAvatarUrl"
                            @error="onImageError(cl, $event)"
                          />
                          <img
                            src="@/assets/pothole.jpg"
                            class="mr-2 media-image"
                            v-else-if="cl.type == 'waze'"
                          />
                          <img
                            src="@/assets/user.jpg"
                            class="mr-2 media-image"
                            v-else
                          />
                          <div class="media-body">
                            <p class="media-title mb-0">
                              {{ cl.socmedUsername }}
                            </p>
                            <div>
                              <p
                                class="text-muted small mb-2 d-inline-block"
                                :title="getMoment('title', cl.timestamp)"
                              >
                                {{ getMoment("display", cl.timestamp) }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        v-if="c.type !== 'whatsapp'"
                        class="d-flex flex-column"
                      >
                        <button
                          v-if="c.type !== 'twitter'"
                          class="
                            btn btn-primary btn-sm
                            rounded-pill
                            align-middle
                          "
                          @click="goToSocMedia(cl)"
                          role="button"
                          style="font-size: 10px"
                        >
                          <font-awesome-icon
                            :icon="getCaseIcon(c.type).i"
                            class="fa-sm mr-2"
                            :class="`text-white`"
                          />View on {{ capitalizeFirstLetter(c.type) }}
                        </button>
                        <button
                          v-if="c.type == 'twitter'"
                          class="
                            btn btn-primary btn-sm
                            rounded-pill
                            align-middle
                          "
                          @click="socialReplyClicked(cl)"
                          role="button"
                          style="font-size: 10px"
                        >
                          <font-awesome-icon
                            :icon="getCaseIcon(c.type).i"
                            class="fa-sm mr-2"
                            :class="`text-white`"
                          />Reply this tweet
                        </button>
                        <button
                          class="
                            btn btn-primary btn-sm
                            rounded-pill
                            align-middle
                            mt-1
                          "
                          @click="addToCase(cl)"
                          role="button"
                          style="font-size: 10px"
                          :disabled="cl.relatedCase"
                        >
                          <font-awesome-icon
                            v-if="!cl.relatedCase"
                            :icon="['fas', 'plus']"
                            class="fa-sm mr-2"
                            :class="`text-white`"
                          />{{ cl.relatedCase ? "Case Added" : "Add to case" }}
                        </button>
                      </div>
                    </div>
                    <p class="mt-3">
                      <text-highlighter :type="cl.type" :text="cl.caption" />
                    </p>
                    <div
                      class="p-1 mt-3 w-100 clickable"
                      v-for="cm in cl.media"
                      :key="cm._id"
                      :id="`dashboardMedia${cm._id}`"
                      @click="currentImage = cm"
                    >
                      <div
                        class="
                          py-3
                          w-100
                          d-flex
                          justify-content-center
                          align-items-center
                          text-muted
                        "
                      >
                        <span
                          class="spinner-border spinner-border-sm mr-2"
                          role="status"
                        >
                        </span>
                        Loading media...
                      </div>
                      {{ loadImage(cm) }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template v-else-if="currentView == 'list'">
            <div class="col-12" style="height: calc(100% - 46px)">
              <div class="d-flex justify-content-end align-items-center">
                <div class="dropdown ml-2">
                  <button
                    id="dropdownMenuButton"
                    type="button"
                    class="
                      btn btn-sm
                      dropdown-toggle
                      btn-light
                      shadow-sm
                      border-primary
                    "
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <font-awesome-icon
                      :icon="['far', 'calendar-alt']"
                      class="mr-2"
                    />
                    {{ computedDateFilter }}
                  </button>
                  <div
                    id="dropdown-menu"
                    class="dropdown-menu px-2"
                    @click.stop
                  >
                    <v-date-picker
                      class="inline-calendar border-0"
                      v-model="dateFilter"
                      :model-config="{
                        type: 'string',
                        mask: 'YYYY-MM-DD',
                      }"
                      mode="date"
                      is-range
                      trim-weeks
                      is-expanded
                    />
                  </div>
                </div>
              </div>
              <div
                class="table-responsive small mt-3 rounded"
                style="height: calc(100% - 29px)"
              >
                <table class="table table-sm table-bordered">
                  <thead class="bg-primary text-light px-3">
                    <tr>
                      <th class="fit-content">#</th>
                      <th>Latitude</th>
                      <th>Longitude</th>
                      <th class="text-center">Media</th>
                      <th class="text-center">Source</th>
                      <th class="text-center">In Johor</th>
                    </tr>
                  </thead>
                  <tbody class="px-3">
                    <tr v-if="computedListCases.length < 1">
                      <td
                        colspan="6"
                        class="text-center text-muted font-italic"
                      >
                        No social media cases found.
                      </td>
                    </tr>
                    <tr
                      v-for="(_case, index) in computedListCases"
                      :key="_case._id"
                    >
                      <td class="font-weight-medium">{{ index + 1 }}</td>
                      <td>{{ parseFloat(_case.lat).toFixed(6) }}</td>
                      <td>{{ parseFloat(_case.lng).toFixed(6) }}</td>
                      <td>
                        <div class="media justify-content-center">
                          <img
                            class="media-image rounded shadow-sm clickable"
                            style="object-fit: cover"
                            :src="helper.formatMediaUrl(_case.media[0])"
                            @click="currentImage = _case.media[0]"
                            v-if="_case.media && _case.media.length > 0"
                          />
                        </div>
                      </td>
                      <td class="text-center">
                        <font-awesome-icon
                          :icon="helper.socialMediaIcons(_case.type).i"
                          :class="`text-${
                            helper.socialMediaIcons(_case.type).color
                          }`"
                          class="fa-2x"
                        />
                      </td>
                      <td class="text-center">
                        <font-awesome-icon
                          :icon="['fas', 'check-circle']"
                          class="text-success fa-2x"
                          v-if="_case.isLocal"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <media-preview
      v-if="currentImage"
      :url="helper.formatMediaUrl(currentImage)"
      @close="currentImage = null"
    />
    <spinner v-if="isProcessing" />
    <social-reply-modal
      :post="postToReply"
      :show="isReplyingPost"
      @close="closeReplySocial"
    />
  </div>
</template>

<script>
import $ from "jquery";
import Swal from "sweetalert2";
import Moment from "moment";
import API from "@/api";
import Helper from "@/helper";
import Spinner from "@/components/Spinner";
import MediaPreview from "@/components/MediaPreview";
import TextHighlighter from "@/components/TextHighlighter";
import SocialReplyModal from "@/modals/SocialReplyModal.vue";

export default {
  name: "social",
  components: {
    MediaPreview,
    spinner: Spinner,
    SocialReplyModal,
    "text-highlighter": TextHighlighter,
  },
  data() {
    return {
      isReplyingPost: false,
      helper: Helper,
      postToReply: null,
      currentImage: null,
      isProcessing: false,
      cases: [],
      isLocal: true,
      currentView: "card",
      dateFilter: {
        start: Moment().startOf("isoWeeks").format("YYYY-MM-DD"),
        end: Moment().endOf("isoWeeks").format("YYYY-MM-DD"),
      },
    };
  },
  watch: {
    dateFilter() {
      $(".dropdown-toggle").dropdown("hide");
    },
  },
  computed: {
    computedDateFilter() {
      return `${Moment(this.dateFilter.start).format("YYYY-MM-DD")} to ${Moment(
        this.dateFilter.end
      ).format("YYYY-MM-DD")}`;
    },
    computedCases() {
      let _cases = JSON.parse(JSON.stringify(this.cases));

      if (this.isLocal) {
        _cases = _cases.map((_case) => {
          _case.data = _case.data.filter((data) => data.isLocal === true);

          return _case;
        });
      }

      return _cases;
    },
    computedListCases() {
      let _cases = JSON.parse(JSON.stringify(this.cases));

      _cases = _cases
        .map((_case) => _case.data)
        .flat()
        .filter((_case) => _case.lat && _case.lng);

      if (this.isLocal) {
        _cases = _cases.filter((_case) => _case.isLocal);
      }

      return _cases;
    },
  },
  methods: {
    addToCase(_case) {
      Swal.fire({
        title: "Add this complaint to case?",
        icon: "question",
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonText: "Confirm",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            this.isProcessing = true;

            let body = JSON.parse(JSON.stringify(_case));

            body.source = "mobileApp";
            body.type = "mobile";
            body.status = "received";
            body.relatedCase = _case._id;
            body.media = body.media ? body.media.map((media) => media._id) : [];
            body.media_during = body.media_during
              ? body.media_during.map((media) => media._id)
              : [];
            body.media_after = body.media_after
              ? body.media_after.map((media) => media._id)
              : [];

            delete body.id;
            delete body._id;

            const { data } = await API.post("cases", body);

            await API.put(`cases/${_case._id}`, {
              relatedCase: data._id,
            });

            await this.getCases();

            Swal.fire("Complaint added to case", "", "success");
          } catch (error) {
            Swal.fire("Error", JSON.stringify(error.message), "error");
          } finally {
            this.isProcessing = false;
          }
        }
      });
    },
    socialReplyClicked(post) {
      this.isReplyingPost = true;
      this.postToReply = post;
    },
    closeReplySocial() {
      this.isReplyingPost = false;
    },
    goToSocMedia(url) {
      window.open(url.socmedPostUrl);
    },
    capitalizeFirstLetter(str) {
      let string = str.charAt(0).toUpperCase() + str.slice(1);
      let result = string.replace(/([a-z])([A-Z])/g, "$1 $2");
      return result;
    },
    loadImage(cm) {
      let img = cm.mime.includes("image")
        ? new Image()
        : document.createElement("VIDEO");

      img.className = "w-100 rounded shadow";

      if (cm.mime.includes("video")) {
        let source = document.createElement("source");

        img.onloadeddata = () => {
          let parent = document.getElementById(`dashboardMedia${cm._id}`);
          if (parent) {
            parent.innerHTML = "";
            parent.appendChild(img);
          }
        };

        source.type = cm.mime;

        source.src = this.helper.formatMediaUrl(cm);

        img.setAttribute("controls", "controls");

        img.appendChild(source);
      } else {
        img.onload = () => {
          let parent = document.getElementById(`dashboardMedia${cm._id}`);

          if (parent) {
            parent.innerHTML = "";
            parent.appendChild(img);
          }
        };

        img.src = this.helper.formatMediaUrl(cm);
      }
    },
    getMoment(type, d) {
      if (!d) {
        return "-";
      } else {
        switch (type) {
          case "title":
            return Moment(d).format("DD MMMM YYYY, hh:mm A");
          case "display":
            return Moment(d).fromNow(false);
          default:
            return "";
        }
      }
    },
    onImageError(cl, event) {
      let image = event.target;

      image.onerror = null;

      image.src = require("@/assets/user.jpg");
    },
    viewCase(caseId) {
      this.$router.push({ name: "inbox", params: { id: caseId } });
    },
    getCaseIcon(type) {
      return Helper.socialMediaIcons(type);
    },
    getCases() {
      this.isProcessing = true;

      API.get(
        "cases?timestamp_null=false&_sort=timestamp:DESC&_limit=-1&source=socialMedia&type_nin=waze&type_nin=instagram"
      )
        .then((retVal) => {
          this.cases = [];

          let rawCases = retVal.data;

          if (rawCases.length > 0) {
            rawCases.forEach((rc) => {
              let rcType = rc.type; //.toLowerCase();

              let caseType = this.cases.find((c) => c.type == rcType);

              if (!caseType) {
                this.cases.push({ type: rcType, data: [rc] });
              } else {
                caseType.data.push(rc);
              }
            });
          }

          this.isProcessing = false;
        })
        .catch((err) => {
          console.error(err);
          this.isProcessing = false;
        });
    },
  },
  async mounted() {
    this.getCases();
  },
};
</script>
